module.exports = __webpack_public_path__ + "img/首页2-5-hover.9f3a23a8.svg";